/**
 * Legend for hold levels. A hold is a ranked option on a date: 1 has first call,
 * 2 is next in line if hold 1 releases, 3 is third. The API returns the same text
 * as `hold_label`; this is the fallback when it is absent.
 */
export const HOLD_LEVEL_LEGEND: Record<number, string> = {
  1: "Hold 1 · first option on the date",
  2: "Hold 2 · second in line behind hold 1",
  3: "Hold 3 · third in line",
};

/**
 * Hold level implied by a status string such as "hold_2". Draft and planned are
 * NOT holds: a hold level only exists when the event has one.
 */
export function inferHoldLevel(status: string): number | null {
  const s = status.toLowerCase().replace(/\s+/g, "_");
  if (s.includes("hold_3") || s === "h3") return 3;
  if (s.includes("hold_2") || s === "h2") return 2;
  if (s.includes("hold_1") || s === "h1" || s === "hold") return 1;
  return null;
}
